













































import { Vue, Component, Prop } from 'vue-property-decorator'
import TableHeader from './TableHeader.vue'
import Tag from './presets/Tag.vue'
import TableImage from './presets/Image.vue'
import Button from './presets/Button.vue'
import ButtonGroup from './presets/ButtonGroup.vue'
import { Column } from './column'

@Component({
  components: {
    TableHeader,
    Tag,
    TableImage,
    Button,
    ButtonGroup
  }
})
export default class TableColumn<T> extends Vue {
  @Prop({ type: Object, required: true }) column!: Column<T>

  handleClick(event: string, row?: T) {
    this.$emit('click', { event, row })
  }

  handleSearch(event: any) {
    this.$emit('search', event)
  }
}
